// Generated from SVG to Code Figma Plugin

export const ProductLineAmount = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3773_1743)">
      <path
        d="M7.19883 19.7997L5.6882 20.0398C4.45609 20.2356 3.31095 19.3603 3.17661 18.12L2.02069 7.44807C1.89616 6.29831 2.69039 5.25111 3.83114 5.06099L8.99883 4.19971"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20.5893 9.52066L19.8903 19.5174C19.8062 20.7194 18.7636 21.6258 17.5616 21.5417L9.94384 21.009C8.74179 20.925 7.83547 19.8824 7.91953 18.6803L8.91226 4.48363C8.99631 3.28158 10.0389 2.37527 11.241 2.45932L16.0118 2.79293"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20.8757 3.30419C21.0018 3.66111 21.248 3.96256 21.5729 4.15683C21.2163 4.28307 20.9153 4.52948 20.7212 4.85412C20.5949 4.49727 20.348 4.19646 20.0229 4.00235C20.3802 3.87612 20.6814 3.62944 20.8757 3.30419Z"
        stroke="currentColor"
        strokeWidth="2.25"
      />
    </g>
    <defs>
      <clipPath id="clip0_3773_1743">
        <rect height="24" width="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);
